import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './FormStage.css';
import Btn from '../../button/btn/Btn.js';
import {Form} from 'formik';
import CheckboxFormik from '../../checkboxFormik/CheckboxFormik.js';
import {DEFAULT_COLOR} from '../../../globalVariables/GlobalVariables.js';

const FormStage = ({onSave}: {onSave: () => void}) => {
    const {t} = useTranslation('suspendedConfirmation');
    
    return (
        <css.wrapper>
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <css.formContainer>
                    <css.title>{t('popupInstructions')}</css.title>
                    {/* <css.checkboxContainer>
                            <CheckboxFormik
                                name="whatsapp"
                                text={t('popupWhatsapp')}
                                color={DEFAULT_COLOR}
                            />
                        </css.checkboxContainer> */}
                    <css.checkboxContainer className="subsequent">
                        <CheckboxFormik
                            name="email"
                            text={t('popupEmail')}
                            color={DEFAULT_COLOR}
                            className="selected"
                        />
                    </css.checkboxContainer>
                    <css.checkboxContainer className="subsequent">
                        <CheckboxFormik
                            name="sms"
                            text={t('popupSms')}
                            color={DEFAULT_COLOR}
                        />
                    </css.checkboxContainer>
                </css.formContainer>
                <css.buttonContainer>
                    <Btn onClick={onSave}>
                        {t('preview')}
                    </Btn>
                </css.buttonContainer>
            </Form>
        </css.wrapper>
    );
};

export default FormStage;
